"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcCollapse = void 0;
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcCollapse = function (props) {
    var tabId = props.tabId, title = props.title, subtitle = props.subtitle, show = props.show, error = props.error, children = props.children;
    var _a = __read(react_1.useState(show !== null && show !== void 0 ? show : false), 2), open = _a[0], setOpen = _a[1];
    var renderBorderHeaderClass = function () {
        var borderClass = 'border-0';
        if (open) {
            borderClass = '';
            if (error) {
                borderClass = 'border-danger';
            }
        }
        return borderClass;
    };
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: "rounded-sm border bg-apzlighterblue " + (error ? 'border-danger' : ''), "data-tabid": tabId },
        react_1.default.createElement(react_bootstrap_1.Card.Header, { onClick: function () { return setOpen(!open); }, className: "bg-transparent p-4 " + renderBorderHeaderClass() },
            react_1.default.createElement("span", { className: "d-flex flex-row align-items-center" },
                react_1.default.createElement("span", { className: "d-flex align-items-center text-primary fs-16 font-weight-bold" },
                    react_1.default.createElement("i", { className: "far " + (open ? 'fa-minus-circle' : 'fa-plus-circle') + " fa-fw fs-24 mr-3" }),
                    react_1.default.createElement("span", null, title)),
                react_1.default.createElement("span", { className: "ml-auto" }, subtitle))),
        react_1.default.createElement(react_bootstrap_1.Collapse, { in: open },
            react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "p-4" }, children))));
};
exports.AcCollapse = AcCollapse;
exports.AcCollapse.displayName = 'AcCollapse';
//# sourceMappingURL=AcCollapse.js.map